<template>
  <div id="js-gnav" class="l-gnav" :class="{ _show: isShow }">
    <div class="l-gnav__inner">
      <div class="l-gnav__body">
        <p class="l-gnav__title u-uppercase">Menu</p>
        <nav class="l-gnav__nav">
          <ul class="l-gnav__list">
            <slot name="nav-item"></slot>
          </ul>
        </nav>
      </div>
      <div class="l-gnav__foot">
        <slot name="foot"></slot>
      </div>
    </div>
    <div class="l-gnav__overlay" />
    <hamburger @hamburger-clicked="showMenu" />
  </div>
</template>

<script>
import hamburger from './hamburger.vue';

export default {
  name: 'GlobalNav',
  components: {
    hamburger,
  },
  data() {
    return {
      isShow: false,
    };
  },
  mounted() {
    this.fixPosition();

    window.addEventListener('scroll', () => {
      this.fixPosition();
    });
  },
  methods: {
    showMenu() {
      this.isShow = !this.isShow;
    },
    fixPosition() {
      document.querySelector(
        '#js-gnav .l-gnav__inner',
      ).style.left = `-${window.pageXOffset}px`;
    },
  },
};
</script>
